// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"a0fa890f","147":"279d3270","229":"6bb2e273","360":"e5d20b6a","381":"94661db2","441":"dbeb596e","467":"da650b36","673":"843b588f","684":"21acd1cf","764":"c4d9993d","895":"39a17ddc","984":"27a4f5b3"}[chunkId] + ".chunk.js";
};